import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { ArrowCircleRight } from './svg/ArrowCircleRight';
import { getTokenValue, THEME_TOKENS } from '@amtrav/theme-system';

const SignInLinkContainer = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  margin: 16px auto;
  white-space: nowrap;
`;

const SignIn = styled.a`
  text-decoration: none;

  &:active,
  &:visited {
    color: ${getTokenValue(THEME_TOKENS.base.color.bodyText)};
  }
`;

const SignInWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const AlreadyText = styled(Flex)`
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

const SignInText = styled.span`
  font-weight: bold;
  color: ${getTokenValue(THEME_TOKENS.base.color.action)};
`;

const Icon = styled.span`
  height: 18px;
  color: ${getTokenValue(THEME_TOKENS.base.color.action)};
`;

const SignInLink = () => {
  return (
    <Flex width={1}>
      <SignInLinkContainer>
        <SignIn href="/">
          <AlreadyText>
            <Box>Already have an account?</Box>
            <SignInWrapper>
              <SignInText>Sign In</SignInText>
              <Icon>
                <ArrowCircleRight />
              </Icon>
            </SignInWrapper>
          </AlreadyText>
        </SignIn>
      </SignInLinkContainer>
    </Flex>
  );
};

export default SignInLink;
